<template>
  <div class="breadcrumb">
    <div class="row primary-filter">
      <div class="back-option">
        <router-link :to="{ name: 'Wallet'}">
          <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
        </router-link>
      </div>
      <div class="dropdown">
        <div class="dropdown-selected">Wallet</div>
      </div>
      <div class="col filter-grid">
        <div class="row">
          <div class="col">
            <div class="app-search-label">
            </div>
          </div>
          <div class="col-md-auto">
            <WalletSearch :hideDatePicker="hideDatePicker"
                          :showFilter = "false"
                          @dateChange ="dateChange"/>
          </div>
        </div>
      </div>
      <div class="action-button">
        <button class="btn btn-secondary" v-if="selectedList.length"
          @click="$emit('markUsed')">Mark used</button>
        <button class="btn btn-primary" @click="$emit('downloadWallet')">Download Unused Wallet</button>
      </div>
    </div>
  </div>
</template>
<script>

import WalletSearch from '@/components/common/app-search';

export default {
  props: ['selectedList'],
  components: {
    WalletSearch,
  },
  data() {
    return {
      dateOne: null,
      dateTwo: null,
      date_range: null,
      hideDatePicker: true,
      showDatePicker: false,
    };
  },

  methods: {
    onClickDatePicker() {
      this.showDatePicker = true;
    },
    dateChange(date) {
      this.$emit('changeDateRange', date);
    },
    applyDates() {
      if (this.dateOne && this.dateTwo) {
        const range = `${this.dateOne}:${this.dateTwo}`;
        this.$emit('changeDateRange', range);
      }
    },
  },
};
</script>
